module.exports = __webpack_public_path__ + "static/media/avatar.80f5cca8.svg";